/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/
import axios from '@/axios.js'
export default {

  fetchTerminalsData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/terminals`)
        .then((response) => {
          commit('SET_TERMINALS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addTerminal (context, authData) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/register`,
        { name: authData.name,
          email: authData.email,
          password: authData.password,
          municipality_id: authData.municipality,
          status: authData.status
        }).then(response => {
        context.commit('SET_TERMINALS', response.data)
        resolve(response)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  }

}
